import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";
import type { PaginationAndOrderParams } from "@src/shared/types/pagination.types";

export interface GetReturnsParams
  extends Partial<
    Omit<PaginationAndOrderParams, "page" | "pageSize" | "orderDirection">
  > {
  page?: number | string;
  pageSize?: number | string;
  search?: string;
  status?: string;
  businessId?: string | number;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
}

export interface ProductReturnItemRecord {
  name?: string | null;
  quantity?: number;
  price?: number;
  totalAmount?: number;
  itemType?: string | null;
}

export interface ProductReturnRecord {
  id?: number | string;
  transactionId?: number | string;
  orderId?: number | string;
  transactionItemId?: number | string;
  productName?: string | null;
  businessName?: string | null;
  customerName?: string | null;
  customerEmail?: string | null;
  reason?: string | null;
  customReason?: string | null;
  status?: string | null;
  refundAmount?: number;
  currency?: string | null;
  createdAt?: string;
  updatedAt?: string;
  inspectionNote?: string | null;
  inspectionStatus?: string | null;
  images?: string[];
  item?: ProductReturnItemRecord;
}

export class ProductReturnService {
  async getReturns(query: GetReturnsParams) {
    return apiService.get("/product-returns", {
      params: sanitizeQueryParams(query),
    });
  }

  async getReturn(id: string) {
    return apiService.get(`/product-returns/${id}`);
  }
}

export const productReturnService = new ProductReturnService();
